import { mergeThemeOverrides } from '@mantine/core';
import { borders } from './borders';
import { colors } from './colors';
import { components } from './components';
import { typeography } from './typeography';
import { shadows } from './shadows';
import { themeToVars } from '@mantine/vanilla-extract';

export const theme = mergeThemeOverrides(borders, colors, shadows, typeography, components);

export const mantineVars = themeToVars(theme);
